import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faDownload, faPrint, faMagic, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import QRCode from 'qrcode';
import { getTenantSlug } from '../../paths';

const BASE = 'https://shop.solutiontechvp.com';

const limpiarNombre = (v) => {
    let s = (v ?? '').trim().toLowerCase();
    s = s.replace(/^https?:\/\//, '');
    s = s.replace(/^shop\.solutiontechvp\.com\/?/, '');
    s = s.replace(/^[^/]*\//, '');
    s = s.replace(/[^a-z0-9-]/g, '');
    s = s.replace(/-+/g, '-');
    s = s.replace(/^-+|-+$/g, '');
    return s;
};

export default function QrData() {
    const [nombre, setNombre] = useState(getTenantSlug() || '');
    const [qrDataUrl, setQrDataUrl] = useState('');
    const [generando, setGenerando] = useState(false);

    const nombreLimpio = limpiarNombre(nombre);
    const urlCompleta = nombreLimpio ? `${BASE}/${nombreLimpio}/` : '';

    const generar = () => {
        if (!urlCompleta) {
            toast.error('Ingresá el nombre de tu página');
            return;
        }
        setGenerando(true);
        QRCode.toDataURL(urlCompleta, { width: 600, margin: 2, errorCorrectionLevel: 'M' })
            .then(dataUrl => { setQrDataUrl(dataUrl); setGenerando(false); })
            .catch(() => { toast.error('No se pudo generar el QR'); setGenerando(false); });
    };

    const cambiarNombre = (valor) => {
        setNombre(valor);
        if (qrDataUrl) setQrDataUrl('');
    };

    const descargar = () => {
        if (!qrDataUrl) return;
        const a = document.createElement('a');
        a.href = qrDataUrl;
        a.download = nombreLimpio ? `qr-${nombreLimpio}.png` : 'qr.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const imprimir = () => {
        if (!qrDataUrl) return;
        const w = window.open('', '_blank');
        if (!w) { toast.error('Permití las ventanas emergentes para imprimir'); return; }
        w.document.write(`<html><head><title>QR</title></head>
            <body style="display:flex;align-items:center;justify-content:center;min-height:100vh;margin:0;">
            <img src="${qrDataUrl}" style="max-width:90%;max-height:90%;" onload="window.print();window.close();" />
            </body></html>`);
        w.document.close();
    };

    return (
        <div style={{ background: '#fff', border: '1px solid #e9ecef', borderRadius: '12px', padding: '20px', marginBottom: '16px', textAlign: 'center' }}>
            <h4 style={{ margin: '0 0 8px', fontSize: '16px', color: '#212529' }}>
                <FontAwesomeIcon icon={faQrcode} style={{ color: 'var(--color1)', marginRight: '8px' }} />
                Generador de QR
            </h4>
            <p style={{ color: '#6c757d', fontSize: '13px', margin: '0 0 14px' }}>
                Escribí el nombre de tu página y generá el QR de tu catálogo para imprimir o descargar.
            </p>

            <div style={{ display: 'flex', gap: '8px', maxWidth: '420px', margin: '0 auto 14px' }}>
                <input
                    type="text"
                    value={nombre}
                    onChange={(e) => cambiarNombre(e.target.value)}
                    placeholder="nombredelapagina"
                    style={{ flex: 1, padding: '10px 12px', border: '1px solid #dee2e6', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                />
                <button
                    onClick={generar}
                    disabled={generando}
                    style={{ padding: '10px 14px', background: 'var(--color1)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
                    title="Generar"
                >
                    <FontAwesomeIcon icon={faMagic} /> Generar
                </button>
            </div>

            {nombreLimpio && (
                <p style={{ color: '#312e81', fontSize: '13px', margin: '0 0 14px', wordBreak: 'break-all' }}>
                    <FontAwesomeIcon icon={faGlobe} style={{ marginRight: '6px' }} />
                    {urlCompleta}
                </p>
            )}

            {qrDataUrl && (
                <img
                    src={qrDataUrl}
                    alt="QR generado"
                    style={{ width: '240px', height: '240px', borderRadius: '12px', border: '1px solid #e9ecef', marginBottom: '14px' }}
                />
            )}

            {generando && <p style={{ color: '#6c757d', fontSize: '13px' }}>Generando...</p>}

            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button
                    onClick={descargar}
                    disabled={!qrDataUrl}
                    style={{ padding: '10px 16px', background: 'var(--color1)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
                >
                    <FontAwesomeIcon icon={faDownload} /> Descargar PNG
                </button>
                <button
                    onClick={imprimir}
                    disabled={!qrDataUrl}
                    style={{ padding: '10px 16px', background: '#312e81', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
                >
                    <FontAwesomeIcon icon={faPrint} /> Imprimir
                </button>
            </div>
        </div>
    );
}
